import { Link } from 'react-router-dom';
import Show from './utility/Show';

const useStyles = ({ selected }) => ({
  link: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    color: selected ? 'rgb(74, 110, 167)' : 'rgb(34, 70, 127)',
    marginRight: '10px',
    textDecoration: 'none',
  },
  icon: {
    padding: 5,
    color: selected ? 'rgb(117, 155, 240)' : 'rgb(34, 70, 127)',
    width: 36,
    height: 36,
  },
});

const IconButton = ({ Icon, text, selected, to }) => {
  const styles = useStyles({ selected });
  return (
    <Link to={to} style={styles.link}>
      <Icon style={styles.icon} />
      <Show test={text}>
        {text}
      </Show>
    </Link>
  );
};

export default IconButton;
